import React, { Component } from 'react'
import {
  Form,
  Container,
  FormGroup,
  Input,
  Button,
  Row,
  Col,
  FormFeedback,
  Alert
} from 'reactstrap'
import $ from 'jquery'
import cx from 'classnames'

import form_img from '../../img/form_img.svg'
import '../../App.css'
import './form.css'

const validateEmail = email => {
  //eslint-disable-next-line
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

class FormSection extends Component {
  state = {
    nameError: false,
    emailError: false,
    formError: false,
    success: false
  }

  handleUserInput = event => {
    event.preventDefault()
    const name = $('#name').val()

    if (!name.length) {
      this.setState({ nameError: true })
    }
  }

  isFormValid = () => {
    const email = $('#email').val()
    const name = $('#name').val()
    const isEmailValid = validateEmail(email)

    if (email || name || isEmailValid) {
      return false
    }

    return true
  }

  handleEmailInput = event => {
    event.preventDefault()
    const email = $('#email').val()
    const isEmailValid = validateEmail(email)

    if (email.length <= 0 || !isEmailValid) {
      this.setState({
        emailError: !this.state.emailError
      })
    }
  }

  focus = () => {
    this.setState({ nameError: false, emailError: false })
    $('#prompt').addClass('d-none')
  }

  submitForm = () => {
    if (this.state.nameError || this.state.emailError || this.isFormValid()) {
      this.setState({ formError: true })
      return false
    }

    this.setState({ formError: false })

    const req = {
      name: $('#name').val(),
      email: $('#email').val(),
      company: $('#company').val()
    }
    const success = $('#successMessage')

    $.ajax({
      url: '/send.php',
      type: 'post',
      data: req,
      success: function(response) {
        success.removeClass('d-none')
        setTimeout(function() {
          success.addClass('d-none')
        }, 10000)
        $('#getDemo')[0].reset()
      },
      error: function(xhr, status, error) {
        console.log(xhr, error, status)
        const errorMessage = $('#dangerMessage')
        errorMessage.removeClass('d-none')
        setTimeout(function() {
          errorMessage.addClass('d-none')
        }, 15000)
        $('#getDemo')[0].reset()
      }
    })

    return false
  }

  render() {
    const { nameError, formError, emailError } = this.state
    return (
      <div className="App-FormSection" id="formSection">
        <Container>
          <Row>
            <Col xs="12" sm="6">
              <div>
                <img
                  src={form_img}
                  className="FormSection-Image"
                  alt="form_img"
                />
              </div>
              <div className="FormSection-Text">
                TobeyApp is the 'amenity' that brings every other amenity to
                life.
              </div>
              <div className="FormSection-Name">
                Paul Johnson,
                <br />
                Rancho Mission Viejo
              </div>
            </Col>

            <Col xs="12" sm="6">
              <div className="Form-title">Interested in learning more?</div>
              {console.log(nameError, emailError)}
              <Form id="getDemo">
                <FormGroup>
                  <Input
                    required
                    id="name"
                    type="text"
                    placeholder="Name"
                    className={cx('Form-input', {
                      'is-invalid': nameError
                    })}
                    onBlur={this.handleUserInput}
                    onKeyUp={this.focus}
                  />
                  {nameError && (
                    <FormFeedback className="formError">
                      Name is required.
                    </FormFeedback>
                  )}
                </FormGroup>
                <FormGroup>
                  <Input
                    id="company"
                    name="company"
                    type="text"
                    placeholder="Company"
                    className="Form-input"
                    onKeyUp={this.focus}
                  />
                </FormGroup>
                <FormGroup>
                  <Input
                    required
                    id="email"
                    type="email"
                    placeholder="Email"
                    className={cx('Form-input', {
                      'is-invalid': emailError
                    })}
                    onBlur={this.handleEmailInput}
                    onKeyUp={this.focus}
                  />
                  {emailError && (
                    <FormFeedback className="formError">
                      Please enter valid Email.
                    </FormFeedback>
                  )}
                </FormGroup>
                <FormGroup className="Button-align">
                  <Button className="Form-button" onClick={this.submitForm}>
                    Schedule Your Demo
                  </Button>
                  {formError && (
                    <p
                      className="formValidationError text-warning mt-2"
                      id="prompt"
                    >
                      Please Enter name and Email to submit the form.
                    </p>
                  )}
                </FormGroup>
                <Alert color="success" id="successMessage" className="d-none">
                  Thank you! A member of our team will be reaching out shortly.
                </Alert>
                <Alert color="danger" id="dangerMessage" className="d-none">
                  Something went wrong with our server. We will fix as soon as
                  possible. Please email your request to{' '}
                  <a href="mailto:itsmeskm99@gmail.com">admin</a>
                </Alert>
              </Form>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default FormSection



// WEBPACK FOOTER //
// ./src/components/FormSection/index.js